module.exports = __webpack_public_path__ + "static/media/29DUNON7.7a57e757.jpg";